import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import type { FC } from "react"

import { PrintPutAwayOrderButton } from "./components/PrintPutAwayOrderButton"
import { useGetGoodsReceiptPalletsForPrint } from "./hooks/useGetGoodsReceiptPalletsForPrint"

import { Button } from "@/components/common/Button"
import { TabletSuccessDialog } from "@/components/common/Modals/TabletSuccessDialog"
import { DATE_FORMAT } from "@/constants/formats"
import { HOLD_AREA_1 } from "@/constants/warehouse"
import type { GoodsReceipt } from "@/graphql/codegen/graphql"
import { useGoodsReceiptPalletActions } from "@/screens/WarehouseReceiving/hooks/useGoodsReceiptPalletActions"
import { isAkrochemManagedWarehouse } from "@/screens/WarehouseReceiving/utils"
import { formatDate } from "@/utils/date"

interface FinalizeCheckInSuccessDialogProps {
  goodsReceipt?: GoodsReceipt
  onClose: () => void
}

export const FinalizeCheckInSuccessDialog: FC<FinalizeCheckInSuccessDialogProps> = ({ goodsReceipt, onClose }) => {
  const { pallets } = useGetGoodsReceiptPalletsForPrint(goodsReceipt?.goodsReceiptId)
  const { handleQrPrintAll } = useGoodsReceiptPalletActions()

  const isAkrochemManaged = isAkrochemManagedWarehouse(goodsReceipt?.warehouseArea?.type)

  if (!goodsReceipt) {
    return null
  }

  return (
    <TabletSuccessDialog title='Products Checked In' agrNumber={goodsReceipt.agrNumber} onClose={onClose}>
      <Typography variant='subtitle1' color='primary' className='font-normal text-gray-900'>
        {pallets.length} pallets checked in
      </Typography>
      <Typography variant='subtitle1' color='primary' className='font-normal text-gray-900'>
        {HOLD_AREA_1}
      </Typography>
      <Typography variant='subtitle1' color='primary' className='font-normal text-gray-900'>
        {formatDate(goodsReceipt.checkedInOn, DATE_FORMAT.US_DATE_TIME)}
      </Typography>
      <Box className='mt-6 flex w-full flex-col gap-6'>
        {isAkrochemManaged && (
          <>
            <Button
              appearance='contained'
              variant='primary'
              className='w-full'
              data-testid='print-all-codes'
              onClick={() => handleQrPrintAll(pallets)}
            >
              Print all QR Codes
            </Button>
            <PrintPutAwayOrderButton
              goodsReceipt={goodsReceipt}
              pallets={pallets}
              buttonProps={{
                appearance: "contained",
                variant: "primary",
                className: "w-full",
                "data-testid": "print-put-away-order-button",
              }}
              buttonLabel='Print Put Away Order'
            />
          </>
        )}
        <Button
          appearance='outlined'
          variant='primary'
          className='w-full'
          onClick={onClose}
          data-testid='done-printing-button'
        >
          Done Printing
        </Button>
      </Box>
    </TabletSuccessDialog>
  )
}
